'use strict';

var React = require('react');

var SelectInput = require('../Common/SelectInput.jsx');
//Action
var YourDetailsActions = require('../../actions/YourDetailsActions.js');
var YourDetailsStore = require('../../stores/YourDetailsStore.js');
var TextInput = require('../Common/TextInput.jsx');

var SourceOfWealth = React.createClass({
    propTypes: {
        index: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.number]),
        data: React.PropTypes.object.isRequired,
        productId: React.PropTypes.number,
        section: React.PropTypes.string,
        errorList: React.PropTypes.array
    },
    getInitialState: function () {
        var sowList = YourDetailsStore.getSourceOfWealthList();

        return { sourceOfWealthList: sowList };
    },
    getDefaultProps: function () {
        return {
            index: '',
            section: '',
            errorList: []
        };
    },

    handleSaveSourceOfWealth: function (event) {
        YourDetailsActions.updateYourDetailsData(event && event.target && event.target.model
                                               , event && event.target && event.target.id
                                               , event && event.target && event.target.value
                                               , this.props && this.props.index);
    },

    render: function () {
        return (
                <div>
                    <SelectInput id={this.props.section + 'sourceOfWealth' + this.props.index}
                                 label="What is your source of wealth?"
                                 value={this.props.data.sourceOfWealth}
                                 onBlur={this.handleSaveSourceOfWealth}
                                 onChange={this.handleSaveSourceOfWealth}
                                 model="sourceOfWealth"
                                 errorList={this.props.errorList}
                                 className="basic-multi-select"
                                 classNamePrefix="select"
                                 options={this.state.sourceOfWealthList}
                                 clearable={true}
                                 searchable={true}
                                 multi={true}
                                 mandatory= {true}/>

                {this.props.data.isOtherSourceOfWealth  ?
                   <TextInput id={this.props.section + 'otherSourceOfWealth' + this.props.index}
                               label="Please specify"
                               value={this.props.data.otherSourceOfWealth}
                               onBlur={this.handleSaveSourceOfWealth}
                               model="otherSourceOfWealth"
                               errorList={this.props.errorList} />  
                    : null}             
                </div>

        );
    }
});

module.exports = SourceOfWealth;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/YourDetails/SourceOfWealth.jsx